import AHref from "../../../../../components/ahref/ahref";
import "./rma-images.scss";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import placeholderImage from "../../../../../images/info-icon.svg";

interface IProps {
    imagesUrls: string[],
}

const RmaImages: React.FC<IProps> = ({ imagesUrls }) => {
    const leadImg = imagesUrls.length > 0 ? imagesUrls[0] : placeholderImage;
    const hiddenImagesCount = imagesUrls.length - 1;
    return (
        <div className="rma-images-container"
            onClick={(e) => e.stopPropagation() /* Prevent opening RMA page */}
        >
            <AHref href={leadImg} target="_blank">
                <img src={leadImg} alt="returns" />
            </AHref>
            {false && hiddenImagesCount > 0 && <FontBody2 color={FONT_COLOR.PRIMARY2}>{`+${hiddenImagesCount}`}</FontBody2>}
        </div>
    );
};


export default RmaImages;
